import { deleteUsers, inviteUsers, useUsers } from '@api/users';
import UsersTable from '@components/Users/UsersTable';
import { USERS_FIELDS } from 'constants/global';
import React from 'react';

const VISIBILITY_MODEL = {
	[USERS_FIELDS.id]: false,
	[USERS_FIELDS.version]: false,
	[USERS_FIELDS.modifiedTime]: false,
	[USERS_FIELDS.logoutTime]: false
};

const EndUsersTable: React.FC = () => (
	<UsersTable
		columnVisibilityModel={VISIBILITY_MODEL}
		getUsers={useUsers}
		adminInvite={false}
		uploadUsersButton
		disableBatchActions={false}
		inviteFunc={inviteUsers}
		deleteFunc={deleteUsers}
	/>
);

export default EndUsersTable;
